// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SticksFormStepSection-module-stepCountLabel-3yNiB{font-weight:450}.SticksFormStepSection-module-title-2-ccl{margin-bottom:10px;color:#373a36}.SticksFormStepSection-module-contentWrapper-2kQBY{display:flex;align-items:flex-start;gap:10px;flex-wrap:wrap}", ""]);
// Exports
exports.locals = {
	"stepCountLabel": "SticksFormStepSection-module-stepCountLabel-3yNiB",
	"title": "SticksFormStepSection-module-title-2-ccl",
	"contentWrapper": "SticksFormStepSection-module-contentWrapper-2kQBY"
};
module.exports = exports;
